var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "bg-white h-101-pct" },
    [
      _c(
        "v-row",
        { class: { "px-5": _vm.smAndDown, "px-12": _vm.mdAndUp } },
        [
          _c(
            "v-col",
            {
              staticClass: "z-index-0",
              class: { "px-4": _vm.smAndDown },
              attrs: { cols: "12" },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "filter-button-row",
                  class: {
                    "mb-3 mt-7": _vm.mdAndUp,
                    "mb-3 mt-2": _vm.smAndDown,
                  },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "my-shipments controls",
                      class: {
                        "pr-3": _vm.sm,
                        "pr-0": _vm.mdAndUp,
                      },
                      attrs: { cols: "12" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "shipments-header" },
                        [
                          _c(
                            "v-col",
                            {
                              attrs: {
                                xl: "2",
                                lg: "3",
                                md: "12",
                                sm: "12",
                                cols: "12",
                              },
                            },
                            [
                              _c("label", { staticClass: "page-heading" }, [
                                _vm._v("My Shipments"),
                              ]),
                            ]
                          ),
                          _vm._l(_vm.availableTabs, function (tab) {
                            return _c(
                              "v-col",
                              {
                                key: tab,
                                staticClass: "details-tab mr-4",
                                class: {
                                  active: _vm.currentTab == tab,
                                },
                                attrs: {
                                  xl: "auto",
                                  lg: "auto",
                                  md: "auto",
                                  sm: "auto",
                                  cols: "7",
                                },
                                on: {
                                  click: function ($event) {
                                    return _vm.tabClicked(tab)
                                  },
                                },
                              },
                              [_c("label", [_vm._v(_vm._s(tab))])]
                            )
                          }),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { class: { "px-5": _vm.smAndDown, "px-15": _vm.mdAndUp } },
        [
          _c(
            "v-col",
            { class: { "px-4": _vm.smAndDown }, attrs: { cols: "12" } },
            [
              _c(
                "v-row",
                { staticClass: "filter-button-row" },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "results-header my-shipments",
                      class: {
                        "pl-0": _vm.mdAndUp,
                        "ta-l": _vm.smAndDown,
                        "pr-0": _vm.md,
                        "pr-3": _vm.sm,
                      },
                      attrs: {
                        cols: "12",
                        sm: "12",
                        md: "auto",
                        lg: "auto",
                        xl: "auto",
                      },
                    },
                    [
                      _c("label", { staticClass: "search-result" }, [
                        _vm._v(
                          _vm._s(
                            _vm.totalCount > 1000
                              ? 1000
                              : _vm.formatNumber(_vm.totalCount)
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "shipments-results-text" }, [
                        _vm._v(" shipment results"),
                      ]),
                    ]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-col",
                    {
                      staticClass: "results-header my-shipments",
                      class: {
                        "pl-0 pr-0": _vm.mdAndUp,
                        "ta-c": _vm.smAndDown,
                        "pr-0": _vm.md,
                        "pr-3": _vm.sm,
                      },
                      attrs: {
                        cols: "12",
                        sm: "12",
                        md: "auto",
                        lg: "auto",
                        xl: "auto",
                      },
                    },
                    [
                      _c(
                        "v-row",
                        { attrs: { "no-gutters": "" } },
                        [
                          _vm.selectedShipments.length
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "mx-1",
                                  attrs: { cols: "auto" },
                                  on: { click: _vm.clearSelection },
                                },
                                [
                                  _c("img", {
                                    staticClass: "hover",
                                    attrs: { src: _vm.ic_delete },
                                  }),
                                ]
                              )
                            : _vm._e(),
                          _vm.selectedShipments.length
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "mx-1 mt-n1 mr-3 hover",
                                  attrs: { cols: "auto" },
                                  on: { click: _vm.clearSelection },
                                },
                                [
                                  _c("span", { staticClass: "stop-name" }, [
                                    _vm._v(
                                      " clear selected (" +
                                        _vm._s(_vm.selectedShipments.length) +
                                        ")"
                                    ),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.currentTab == "Pending Orders"
                            ? _c("v-col", { attrs: { cols: "auto" } }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.ic_merge_bold,
                                    width: "24",
                                    title: "This icon indicates a merged order",
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm.currentTab == "Pending Orders"
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ml-2 mt-n1 mr-3",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("label", { staticClass: "statuses-lbl" }, [
                                    _vm._v("Merged Orders"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _vm.currentTab != "Pending Orders"
                            ? _c("v-col", { attrs: { cols: "auto" } }, [
                                _c("img", {
                                  attrs: {
                                    src: _vm.ic_consolidate,
                                    width: "24",
                                    title:
                                      "This icon indicates a consolidated shipment",
                                  },
                                }),
                              ])
                            : _vm._e(),
                          _vm.currentTab != "Pending Orders"
                            ? _c(
                                "v-col",
                                {
                                  staticClass: "ml-2 mt-n1 mr-3",
                                  attrs: { cols: "auto" },
                                },
                                [
                                  _c("label", { staticClass: "statuses-lbl" }, [
                                    _vm._v("Consolidated"),
                                  ]),
                                ]
                              )
                            : _vm._e(),
                          _c(
                            "v-col",
                            { staticClass: "mx-1", attrs: { cols: "auto" } },
                            [
                              _c("img", {
                                staticClass: "orig-pin",
                                attrs: { src: _vm.ic_pin_blue_v2 },
                              }),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "mx-1 mt-n1 mr-3",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("label", { staticClass: "stop-name" }, [
                                _vm._v("Origin "),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            { staticClass: "mx-1", attrs: { cols: "auto" } },
                            [
                              _c("img", {
                                staticClass: "dest-pin",
                                attrs: { src: _vm.ic_pin_blue_v2 },
                              }),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "mx-1 mt-n1 mr-3",
                              attrs: { cols: "auto" },
                            },
                            [
                              _c("label", { staticClass: "stop-name" }, [
                                _vm._v("Destination "),
                              ]),
                            ]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "hover status-icon-wrapper",
                              attrs: { cols: "auto" },
                              on: {
                                click: function ($event) {
                                  _vm.showStatusDefinitions = true
                                },
                              },
                            },
                            [_c("img", { attrs: { src: _vm.ic_blue_circle } })]
                          ),
                          _c(
                            "v-col",
                            {
                              staticClass: "ml-2 mt-n1 hover",
                              attrs: { cols: "auto" },
                              on: {
                                click: function ($event) {
                                  _vm.showStatusDefinitions = true
                                },
                              },
                            },
                            [
                              _c(
                                "label",
                                { staticClass: "statuses-lbl hover" },
                                [_vm._v("Statuses")]
                              ),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                {
                  staticClass: "mt-2 filter-button-row",
                  class: { "mb-8": _vm.mdAndUp, "mb-10": _vm.smAndDown },
                },
                [
                  _c(
                    "v-col",
                    {
                      staticClass: "my-shipments search",
                      class: {
                        "pl-0": _vm.mdAndUp,
                        "ta-c": _vm.smAndDown,
                        "pr-0": _vm.md,
                        "pr-3": _vm.sm,
                      },
                      attrs: {
                        cols: "12",
                        sm: "12",
                        md: "12",
                        lg: "5",
                        xl: "5",
                      },
                    },
                    [
                      _c("smart-text-field", {
                        attrs: {
                          placeholder: "Search",
                          search: true,
                          clearable: true,
                          "css-class": {
                            "mt-2": _vm.mdAndUp,
                            "search-field": true,
                          },
                        },
                        on: {
                          clear: _vm.clearFiltersV2,
                          "enter-pressed": function ($event) {
                            return _vm.quickSearch()
                          },
                        },
                        model: {
                          value: _vm.quickSearchTerm,
                          callback: function ($$v) {
                            _vm.quickSearchTerm = $$v
                          },
                          expression: "quickSearchTerm",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "my-shipments controls",
                      class: {
                        "pr-3": _vm.sm,
                        "pr-0": _vm.mdAndUp,
                      },
                      attrs: {
                        cols: "12",
                        sm: "12",
                        md: "12",
                        lg: "7",
                        xl: "7",
                      },
                    },
                    [
                      _c("my-shipment-buttons", {
                        attrs: { "show-combine": _vm.showCombine },
                        on: {
                          csvExport: _vm.csvExportV2,
                          displayFilters: function ($event) {
                            _vm.displayFilters = true
                          },
                          clearFilters: _vm.clearFiltersV2,
                          combine: _vm.combine,
                          dataExtractByAccount: _vm.dataExtractByAccount,
                          noData: _vm.noData,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        {
          class: { "px-5": _vm.smAndDown, "px-15 mt-n8": _vm.mdAndUp },
          attrs: { justify: !_vm.miniMap ? "center" : "start" },
        },
        [
          _c(
            "v-col",
            {
              class: { "px-4 mt-n4": _vm.smAndDown, "pr-6 pt-0": _vm.mdAndUp },
              attrs: {
                xl: _vm.showGrid ? 12 : 7,
                lg: _vm.showGrid ? 12 : 8,
                md: _vm.showGrid ? 12 : !_vm.miniMap ? 12 : 8,
                sm: "12",
                cols: "12",
                "order-lg": _vm.cardsOrder,
                "order-xl": _vm.cardsOrder,
                "order-md": _vm.cardsOrder,
                "order-sm": _vm.cardsOrder,
                order: _vm.cardsOrder,
              },
            },
            [
              _c(
                "v-row",
                [
                  !_vm.loading && _vm.showCards
                    ? _c(
                        "v-col",
                        {
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            xl12: "",
                          },
                        },
                        _vm._l(_vm.page, function (ship) {
                          return _c(
                            "v-layout",
                            { key: ship.shipmentId, attrs: { row: "" } },
                            [
                              _c("shipment-card", {
                                attrs: {
                                  shipment: ship,
                                  elevation: true,
                                  selectable: true,
                                  "current-tab": _vm.currentTab,
                                },
                                on: {
                                  copied: function (id) {
                                    return _vm.copied(id)
                                  },
                                  showDetails: function (id) {
                                    return _vm.showDetails(id)
                                  },
                                  confirmDelete: function (id) {
                                    return _vm.confirmDelete(id)
                                  },
                                  confirmCancel: function (id) {
                                    return _vm.confirmCancel(id)
                                  },
                                  confirmUndelete: function (id) {
                                    return _vm.confirmUndelete(id)
                                  },
                                  makeCopy: function (id) {
                                    return _vm.makeCopy(id)
                                  },
                                  "no-tracking": _vm.noTracking,
                                  "open-docs": _vm.openDocs,
                                  unmerged: _vm.unmerged,
                                  incidentReported: _vm.incidentReported,
                                  resendShipmentConfirmPopup:
                                    _vm.resendShipmentConfirmPopup,
                                  openSchedulePopup: _vm.openSchedulePopup,
                                  rejectError: _vm.rejectError,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  !_vm.loading && _vm.showGrid
                    ? _c(
                        "v-col",
                        {
                          staticClass: "my-shipments-grid-wrapper mb-5",
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            xl12: "",
                          },
                        },
                        [
                          _c("my-shipments-grid", {
                            attrs: { page: _vm.page },
                            on: {
                              copied: function (id) {
                                return _vm.copied(id)
                              },
                              showDetails: function (id) {
                                return _vm.showDetails(id)
                              },
                              confirmDelete: function (id) {
                                return _vm.confirmDelete(id)
                              },
                              confirmCancel: function (id) {
                                return _vm.confirmCancel(id)
                              },
                              makeCopy: function (id) {
                                return _vm.makeCopy(id)
                              },
                              "no-tracking": _vm.noTracking,
                              "open-docs": _vm.openDocs,
                              unmerged: _vm.unmerged,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-col",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    !_vm.showNoData &&
                    (!_vm.showGrid || (_vm.showGrid && _vm.showMap)),
                  expression:
                    "!showNoData && (!showGrid || (showGrid && showMap))",
                },
              ],
              staticClass: "pr-0 trasition-016",
              class: {
                "px-4 pl-0 mt-n12": _vm.smAndDown,
                "pl-0": !_vm.miniMap,
              },
              attrs: {
                sm: "12",
                lg: _vm.miniMap && _vm.mdAndUp ? 4 : 12,
                xl: _vm.miniMap && _vm.mdAndUp ? 5 : 12,
                md: _vm.miniMap && _vm.mdAndUp ? 4 : 12,
                "order-lg": _vm.mapOrder,
                "order-xl": _vm.mapOrder,
                "order-md": _vm.mapOrder,
                "order-sm": _vm.mapOrder,
                order: _vm.mapOrder,
              },
            },
            [
              _c(
                "div",
                { staticClass: "map-wrap" },
                [
                  _vm.mdAndUp
                    ? _c(
                        "v-btn",
                        {
                          staticClass: "map-expander test",
                          attrs: {
                            absolute: "",
                            right: "",
                            fab: "",
                            small: "",
                            raised: "",
                            ripple: false,
                          },
                          on: { click: _vm.toggleMap },
                        },
                        [
                          _c("v-icon", [
                            _vm._v(
                              _vm._s(
                                _vm.miniMap
                                  ? "mdi-chevron-left"
                                  : "mdi-chevron-right"
                              )
                            ),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-row",
                    { attrs: { "no-gutters": "" } },
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "mt-n6 map-wrapper",
                          attrs: { cols: "12" },
                        },
                        [
                          _c("interactive-map-azure", {
                            key: _vm.mapKey,
                            attrs: { shipments: _vm.pageComputed },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _vm.showNoData
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "ta-c",
                          class: {
                            "mt-16": _vm.lgAndUp,
                            "mt-n6 mb-12": _vm.smAndDown,
                          },
                          attrs: { cols: "12" },
                        },
                        [_c("no-data")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loading && _vm.shipments.length && _vm.showPagingV2
        ? _c(
            "v-layout",
            { staticClass: "mt-6 mb-n4" },
            [
              _c(
                "v-flex",
                { staticClass: "mt-3" },
                [
                  _c("v-pagination", {
                    staticClass: "pl-3",
                    attrs: {
                      length: _vm.pagingLengthV2,
                      "total-visible": 10,
                      "show-first-last-page": true,
                    },
                    on: { input: _vm.pageChangeV2 },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c("smart-toast", {
        attrs: { display: _vm.snackbar, message: _vm.snackbarText },
        on: {
          close: function ($event) {
            _vm.snackbar = false
          },
        },
      }),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "#007BFF", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbarError = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbarError,
            callback: function ($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError",
          },
        },
        [
          _c("img", {
            staticClass: "success-icon",
            attrs: { src: _vm.ic_warning_orange },
          }),
          _vm._v(" " + _vm._s(_vm.snackbarErrorText) + " "),
        ]
      ),
      _c("br"),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", width: _vm.filtersWidth, eager: "" },
          model: {
            value: _vm.displayFilters,
            callback: function ($$v) {
              _vm.displayFilters = $$v
            },
            expression: "displayFilters",
          },
        },
        [
          _c("shipment-filters", {
            attrs: { searchInProgress: _vm.loading },
            on: {
              search: _vm.search,
              close: function ($event) {
                _vm.displayFilters = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.showGrid,
              expression: "!showGrid",
            },
          ],
          staticClass: "navigation-details",
          class: {
            active: _vm.displayDetails && !_vm.showGrid,
            "w-100-pct": _vm.smAndDown,
          },
        },
        [
          _c("shipment-overview", {
            attrs: { shipment: _vm.selectedShipment },
            on: {
              hide: function ($event) {
                _vm.displayDetails = false
              },
              copied: _vm.copied,
              "open-docs": _vm.openDocsAndScrollUp,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayConfirmDelete,
            callback: function ($$v) {
              _vm.displayConfirmDelete = $$v
            },
            expression: "displayConfirmDelete",
          },
        },
        [
          _c("confirm-delete-shipment", {
            attrs: { deleting: _vm.deleting },
            on: {
              close: function ($event) {
                _vm.displayConfirmDelete = false
              },
              softDeleteShipment: _vm.softDeleteShipment,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.displayConfirmCancel,
            callback: function ($$v) {
              _vm.displayConfirmCancel = $$v
            },
            expression: "displayConfirmCancel",
          },
        },
        [
          _c("confirm-cancel-edi-shipment", {
            on: {
              close: function ($event) {
                _vm.displayConfirmCancel = false
              },
              cancelShipment: _vm.cancelShipment,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "660px" },
          model: {
            value: _vm.showShipmentCancelFailedPopup,
            callback: function ($$v) {
              _vm.showShipmentCancelFailedPopup = $$v
            },
            expression: "showShipmentCancelFailedPopup",
          },
        },
        [
          _c("cancel-edi-shipment-failed", {
            attrs: {
              info: _vm.shipmentCancelFailedInfoComputed,
              state: _vm.currentCancellationStateComputed,
            },
            on: {
              close: function () {
                _vm.shipmentCancelFailedInfo = null
                _vm.showShipmentCancelFailedPopup = false
              },
              successfullyCancelled: _vm.successfullyCancelledManual,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.showShipmentSuccessfullyCancelledPopup,
            callback: function ($$v) {
              _vm.showShipmentSuccessfullyCancelledPopup = $$v
            },
            expression: "showShipmentSuccessfullyCancelledPopup",
          },
        },
        [
          _c("shipment-successfully-cancelled", {
            attrs: { shipmentId: _vm.currentShipmentId },
            on: { close: _vm.shipmentSuccessfullyCancelledPopupClosed },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayConfirmUndelete,
            callback: function ($$v) {
              _vm.displayConfirmUndelete = $$v
            },
            expression: "displayConfirmUndelete",
          },
        },
        [
          _c("confirm-delete-shipment", {
            attrs: { deleting: _vm.undeleting, undelete: true },
            on: {
              close: function ($event) {
                _vm.displayConfirmUndelete = false
              },
              undeleteShipment: _vm.undeleteShipment,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayMakeCopy,
            callback: function ($$v) {
              _vm.displayMakeCopy = $$v
            },
            expression: "displayMakeCopy",
          },
        },
        [
          _c("copy-order", {
            attrs: { shipmentId: _vm.currentShipmentId },
            on: {
              hide: function ($event) {
                _vm.displayMakeCopy = false
              },
              copy: _vm.copyOrder,
            },
          }),
        ],
        1
      ),
      _c("documents", {
        attrs: {
          shipmentId: _vm.currentShipmentId,
          display: _vm.displayDocuments,
        },
        on: {
          hide: function ($event) {
            _vm.displayDocuments = false
          },
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "724px" },
          model: {
            value: _vm.showStatusDefinitions,
            callback: function ($$v) {
              _vm.showStatusDefinitions = $$v
            },
            expression: "showStatusDefinitions",
          },
        },
        [
          _c("status-definitions", {
            on: {
              close: function ($event) {
                _vm.showStatusDefinitions = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayNoTracking,
            callback: function ($$v) {
              _vm.displayNoTracking = $$v
            },
            expression: "displayNoTracking",
          },
        },
        [
          _c("no-external-tracking", {
            on: {
              displayNoTracking: function ($event) {
                _vm.displayNoTracking = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          key: _vm.rerenderMergeWindow,
          attrs: { width: _vm.consolidationPopupWidth, scrollable: "" },
          model: {
            value: _vm.showMergeWindow,
            callback: function ($$v) {
              _vm.showMergeWindow = $$v
            },
            expression: "showMergeWindow",
          },
        },
        [
          _c("combine-orders", {
            on: {
              close: _vm.combineOrdersClosed,
              "copy-order-ids": _vm.copyOrderIds,
              "copy-booked-id": _vm.copyBookedId,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", width: "580px" },
          model: {
            value: _vm.showAddIncidentPopup,
            callback: function ($$v) {
              _vm.showAddIncidentPopup = $$v
            },
            expression: "showAddIncidentPopup",
          },
        },
        [
          _c("new-service-incident", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showAddIncidentPopup,
                expression: "showAddIncidentPopup",
              },
            ],
            attrs: { id: _vm.currentShipmentId },
            on: {
              close: function ($event) {
                _vm.showAddIncidentPopup = false
              },
              created: _vm.newIncidentSaved,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", width: "580px", eager: "" },
          model: {
            value: _vm.showResendShipmentConfirmPopup,
            callback: function ($$v) {
              _vm.showResendShipmentConfirmPopup = $$v
            },
            expression: "showResendShipmentConfirmPopup",
          },
        },
        [
          _c("resend-shipment-confirmation", {
            attrs: {
              display: _vm.showResendShipmentConfirmPopup,
              shipmentId: _vm.currentShipmentId,
            },
            on: {
              hide: _vm.closeShipmentConfirmationPopup,
              sent: _vm.shipmentConfirmationEmailSent,
            },
          }),
        ],
        1
      ),
      _vm.showExtractDataByAccount
        ? _c("data-extract-by-account", {
            attrs: { display: _vm.showExtractDataByAccount },
            on: {
              close: function ($event) {
                _vm.showExtractDataByAccount = false
              },
              extractedSuccessfully: _vm.dataExtractedSuccessfully,
            },
          })
        : _vm._e(),
      _vm.showScheduleShipmentPopup
        ? _c("schedule-shipment", {
            ref: "scheduleShipment",
            attrs: {
              display: _vm.showScheduleShipmentPopup,
              shipmentId: _vm.scheduleShipmentId,
            },
            on: {
              close: _vm.closeScheduleShipmentPopup,
              saved: _vm.loadScheduled,
            },
          })
        : _vm._e(),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(_vm._s(_vm.loadingMsg)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }